import { render, staticRenderFns } from "./AssociadoList.vue?vue&type=template&id=0861d79a"
import script from "./AssociadoList.vue?vue&type=script&lang=js"
export * from "./AssociadoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports